module.exports = __webpack_public_path__ + "static/media/CornIcon.b102d3bb.svg";